import Vue from 'vue'
import Element from 'element-ui'
import '@/assets/css/theme/index.css'

Vue.use(Element)
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
